import { render, staticRenderFns } from "./App3.vue?vue&type=template&id=42522712&"
import script from "./App3.vue?vue&type=script&lang=js&"
export * from "./App3.vue?vue&type=script&lang=js&"
import style0 from "./App3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports